import React from 'react';
import { storageService } from '../../services';
import useIdle from './useIdleTimeout';
import { identityAuth } from '../../auth';

// IdleTimerContainer component is used to consume useIdle hook
const IdleTimerContainer = (props) => {
  const logout = async () => {
    await identityAuth.logout();
    console.log('User got logged out');
  };
  useIdle({
    onIdle: logout,
    idleTime: 30,
  });
  return <></>;
};
export default IdleTimerContainer;
